"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'PeriodPane',
  //资源授权
  directives: {
    waves: _waves.default
  },
  props: ["authOrgData"],
  data: function data() {
    return {
      periodData: {
        //租赁信息
        orgId: undefined,
        domain: '',
        startDate: '',
        expireDate: '',
        reserveDay: '',
        passwordComplexity: ''
      }
    };
  },
  created: function created() {},
  watch: {},
  methods: {}
};